import PropTypes from 'prop-types';
// material
import { Divider, List, ListItemButton, Stack, Tooltip, Typography } from '@mui/material';

import { useSelector } from 'react-redux';
import moment from 'moment';
import { Fragment } from 'react';
import { speedConverter } from '../../common/utils/unitConverter';
import { useTranslation } from '../../common/LocalizationProvider';
import { selectSession } from '../../createSelectorUtils';

// utils

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

FlightReviewTakeOff.propTypes = {
  positions: PropTypes.array,
  analyse: PropTypes.object,
  state: PropTypes.object,
  setState: PropTypes.func,
  device: PropTypes.object
};
export default function FlightReviewTakeOff({ analyse, positions, state, setState, device }) {
  const t = useTranslation();

  const session = useSelector(selectSession);
  return (
    <List>
      {analyse.analyseDecollageReports.map((decollage, index) => (
        <Fragment key={index}>
          <ListItemButton
            selected={state.selectedListItem === index}
            onClick={() =>
              setState({
                ...state,
                selectedListItem: index,
                currentPosition: positions.indexOf(
                  positions.find((item) => item.id === decollage.pointPositionId)
                )
              })
            }
            key={`info-${index}`}
          >
            <Stack direction="column" key={`stackInfo-${index}`}>
              <Typography variant="subtile1">{`n° ${index + 1} - ${moment(
                positions.find((item) => item.id === decollage.pointPositionId).fixTime
              ).format('HH:mm:ss')} ${t('words_From')} ${decollage.oaci}`}</Typography>
              {decollage.distance > 0 && (
                <Typography variant="subtitle1">
                  {`Distance: ${decollage.distance.toFixed(0)} m`}
                </Typography>
              )}
            </Stack>
          </ListItemButton>
          {decollage.speedAlert ? (
            <Tooltip
              title={`Vous étiez en dessous de la vitesse de montée (
                ${speedConverter(device.speedMinMontee, session.uniteVitesse)} ${
                  session.uniteVitesse
                })`}
              placement="top"
              key={`speedAlert-${index}`}
            >
              <ListItemButton
                selected={state.selectedListItem === index}
                onClick={() =>
                  setState({
                    ...state,
                    selectedListItem: index,
                    currentPosition: positions.indexOf(
                      positions.find((item) => item.id === decollage.speedAlert)
                    )
                  })
                }
              >
                <Typography variant="subtitle1" style={{ color: '#bb0b0b' }}>
                  {`Alerte vitesse: ${speedConverter(
                    positions.find((position) => position.id === decollage.speedAlert).speed,
                    session.uniteVitesse
                  )} ${session.uniteVitesse}`}
                </Typography>
              </ListItemButton>
            </Tooltip>
          ) : null}
          <Divider />
        </Fragment>
      ))}
    </List>
  );
}
